<template>
  <span>
    <v-dialog v-model="confirm" width="500">
      <template v-slot:activator="{ on, attrs }">
        <i-btn
          v-if="!isReadonly"
          elevation="0"
          color="white"
          outlined
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="material-icons-outlined" left>
            settings
          </v-icon>
          {{ $t('기본정보 변경') }}</i-btn
        >
      </template>
      <v-card v-if="confirm && !check">
        <v-card-title class="pt-7 pb-5 px-7"
          >{{ $t('기본정보 확인') }}
        </v-card-title>
        <v-card-text class="pb-0 px-7">
          <v-divider></v-divider>
          <div class="desc-wrap">
            <p class="desc mt-5 mb-5">
              {{ $t('본인확인을 위해 비밀번호를 입력해 주세요.') }}
            </p>
            <v-row>
              <v-col cols="12">
                <i-text-field
                  v-model="password"
                  :type="showpwd ? 'text' : 'password'"
                  placeholder="비밀번호 입력"
                  outlined
                  hide-details="auto"
                  single-line
                  dense
                  @keyup.enter="confirmPwd"
                ></i-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions class="pt-5 pb-7 px-7">
          <v-spacer></v-spacer>
          <i-btn elevation="0" color="primary" @click="confirmPwd">{{
            $t('확인')
          }}</i-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="dialog">
        <v-card-title class="pt-7 pb-5 px-7">{{
          $t('기본정보 변경')
        }}</v-card-title>
        <v-card-text class="pb-0 px-7">
          <v-divider></v-divider>
          <div class="infoList-wrap">
            <ul class="infoList">
              <li>
                <span class="list-label">{{ $t('이름') }}</span>
                <span class="list-desc">
                  <i-text-field
                    v-model="name"
                    single-line
                    outlined
                    hide-details="auto"
                    dense
                    class="rounded-l-0 rounded-r"
                  ></i-text-field>
                </span>
              </li>
              <li>
                <span class="list-label">Phone</span>
                <span class="list-desc"
                  ><i-text-field
                    v-model="phone"
                    single-line
                    outlined
                    hide-details="auto"
                    @blur="formattedPhoneNumber()"
                    dense
                    class="rounded-l-0 rounded-r"
                  ></i-text-field
                ></span>
              </li>
              <li>
                <span class="list-label">E-mail</span>
                <span class="list-desc"> {{ user.email }}</span>
              </li>
            </ul>
          </div>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions class="pt-5 pb-7 px-7">
          <v-spacer></v-spacer>
          <i-btn elevation="0" color="primary" @click="save">저장</i-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import { getEncryption, postAuthJson } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { formatPhoneNumber } from '@/utils/filters';

import RSAKey from '@/utils/rsa/rsa.js';

export default {
  mixins: [DialogMixin],
  props: {
    user: { type: Object },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    confirm: false,
    dialog: false,
    check: false,
    showpwd: false,
    password: '',
    name: '',
    email: '',
    phone: '',
    otp: '',
  }),
  methods: {
    setting: function() {
      this.name = this.user.name;
      this.email = this.user.email;
      this.phone = this.user.phone;
    },
    confirmPwd: async function() {
      const rsa = new RSAKey();
      const {
        publicKeyModulus,
        publicKeyExponent,
        sessionKey,
      } = await getEncryption();
      rsa.setPublic(publicKeyModulus, publicKeyExponent);

      const p = {
        password: rsa.encrypt(this.password),
        sessionKey: sessionKey,
      };
      postAuthJson('api/v1/' + this.$route.params.tenantKey + '/confirmpwd', p)
        .then(res => {
          this.password = '';
          this.check = true;
          this.dialog = true;
          this.otp = res.data.otp;
        })
        .catch(error => {
          console.log(error.response);
          this.$showAlert({
            message: '비밀번호가 일치하지 않습니다.',
            title: '',
          });
        });
    },
    save: async function() {
      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      const rsa = new RSAKey();
      const {
        publicKeyModulus,
        publicKeyExponent,
        sessionKey,
      } = await getEncryption();
      rsa.setPublic(publicKeyModulus, publicKeyExponent);

      const p = {
        annoId: this.$route.params.annoId,
        name: rsa.encrypt(this.name),
        phone: rsa.encrypt(this.phone.replace(pattern, '')),
        otp: this.otp,
        sessionKey: sessionKey,
      };
      postAuthJson('api/v1/' + this.$route.params.tenantKey + '/change/user', p)
        .then(res => {
          if (res.status !== 200) {
            console.log('USER SAVE INFO FAIL');
          } else {
            const v = {
              message: '사용자 정보가 변경되었습니다.',
              title: '',
              callback: this.callback,
            };
            this.$showAlert(v);
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    formattedPhoneNumber: function() {
      this.phone = formatPhoneNumber(this.phone);
    },
    callback: function() {
      this.dialog = false;
      this.check = false;
      this.confirm = false;
      this.$emit('reset');
    },
  },
};
</script>
<style>
.v-dialog > .v-card > .v-card__title {
  font-weight: bold;
}
.infoList-wrap {
  min-height: 292px;
}
.infoList {
  margin-top: 10px;
}
.infoList li {
  line-height: 36px;
  min-height: 36px;
  padding: 10px 0px;
  list-style: none;
  border-bottom: 1px solid #f6f6f6;
}
.infoList li:first-child {
  padding-top: 0px;
}
.infoList li::after {
  content: '';
  display: table;
  clear: both;
}
.infoList li span {
  display: inline-block;
  vertical-align: middle;
}
.infoList li .list-label {
  width: 23%;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.28px;
  color: #292929;
}
.infoList li .list-desc {
  width: 50%;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.28px;
  color: #788794;
}
.infoList li span.btn-wrap {
  float: right;
}
</style>
